import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Commons } from '../shared/Commons';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  private scrollEvent = new BehaviorSubject<string | null>(null); // Emite eventos de desplazamiento
  scrollEvent$ = this.scrollEvent.asObservable(); // Observable que otros pueden escuchar

  scrollTo(section: string) {
    this.scrollEvent.next(section); // Guarda el evento
  }

  getPendingScroll(): string | null {
    return this.scrollEvent.getValue(); // Devuelve el último evento si existe
  }

  clearScroll() {
    this.scrollEvent.next(null); // Limpia el evento después de ejecutarlo
  }

  /**
   * Navega hacia una sección embebida en el Home ('home' mode, ver environment.home.*).
   * Si ya se está en el Home, hace scroll directo; si se está en otra página, navega
   * al Home y luego dispara el scroll. SOLO debe invocarse cuando la sección está en
   * modo 'home' — cuando está en modo 'page' se debe usar routerLink hacia su ruta
   * dedicada en lugar de este método (ver skill "section-navigation").
   */
  goToSection(router: Router, section: string): void {
    const isHome = router.url === `/${Commons.PATH_MAIN}`;
    if (isHome) {
      this.scrollTo(section);
    } else {
      router.navigate([`/${Commons.PATH_MAIN}`]).then(() => this.scrollTo(section));
    }
  }
}
